module.exports = __webpack_public_path__ + "img/vegetable-ginger-190x100.0030503d.jpg";